"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _DiscountItem = require("../DiscountItem/DiscountItem.prototype");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    data: _propTypes.default.arrayOf(_propTypes.default.shape(_DiscountItem.DiscountData)).isRequired,
    selectedData: _propTypes.default.arrayOf(_propTypes.default.shape(_DiscountItem.DiscountData)),
    isLoading: _propTypes.default.bool,
    translations: _propTypes.default.objectOf(_propTypes.default.shape({
      selectPromo: _propTypes.default.string,
      noPromoTitle: _propTypes.default.string,
      noPromoDesc: _propTypes.default.string
    })),
    onSelectDiscount: _propTypes.default.func,
    onClickTnC: _propTypes.default.func
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    isLoading: false,
    data: [],
    selectedData: [],
    translations: {
      labelSelectPromo: "Select promo code",
      labelNoPromoTitle: "Got a promo code?",
      labelNoPromoDesc: "Enter it or swing by later when you have one"
    },
    onSelectDiscount: function onSelectDiscount() {},
    onClickTnC: function onClickTnC() {}
  }
};
exports.default = _default;